// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IySx_","field":"styles_field__2oSQX","fieldCol":"styles_fieldCol__31CCk","diffCol":"styles_diffCol__3GYXZ","diff":"styles_diff__-limz"};